export interface EpocusReceiver {
  id: string;
  name: string;
  role: string;
  facility: string;
}

// IDs must match REVIEWERS in reviewers.ts — these are the demo viewer identities
// used by the dev user swapper, so referrals route to the correct inbox.
export const HARDCODED_RECEIVERS: EpocusReceiver[] = [
  {
    id: "torres",
    name: "Dr. Michael Torres",
    role: "Cardiology",
    facility: "Regional Medical Centre",
  },
  {
    id: "chen",
    name: "Dr. Sarah Chen",
    role: "Emergency Medicine / POCUS",
    facility: "Kumasi South Hospital",
  },
  {
    id: "patel",
    name: "Dr. Priya Patel",
    role: "Internal Medicine",
    facility: "Kumasi South Hospital",
  },
  {
    id: "kim",
    name: "Dr. Alex Kim",
    role: "Emergency Medicine",
    facility: "Kumasi South Hospital",
  },
];
